import clsx from 'clsx';

export default function ActionButton({
    'aria-label': ariaLabel,
    className,
    'data-testid': dataTestId,
    disabled,
    icon,
    label,
    onClick,
}: ActionButtonProps) {
    const buttonClasses = clsx('action-button', icon, className);

    return (
        <button
            aria-label={ariaLabel ?? label}
            className={buttonClasses}
            data-testid={dataTestId}
            disabled={disabled}
            onClick={onClick}
            type="button"
        >
            {label}
        </button>
    );
}